module.exports = __webpack_public_path__ + "img/park.0975505a.png";